import React, { ReactElement, useEffect, useRef } from 'react';
import './DesktopHeader.scss';
import Free from '../../ReadFree/Free';
import KodanshaBreadCrumb from '../../../../KodanshaUIKit/KodanshaBreadCrumb/KodanshaBreadCrumb';
import KodanshaPoster from '../../../../KodanshaUIKit/KodanshaPoster/KodanshaPoster';
import { Creator } from '../../../../../Models/Creator';
import {
    BlueColorForNotImageFound,
    formTheAssetGroup,
    getRandomColor,
    getSeriesColor,
    mapCreators,
} from '../../../../../utils/utils';
import ProductPoster from '../../../../KodanshaUIKit/ProductPoster/ProductPoster';
import SeriesPoster from '../../../../KodanshaUIKit/SeriesPoster/SeriesPoster';
import { useHistory } from 'react-router-dom';
import { Link } from '../../../../../Devon/Components/InkyLink';
import KodanshaAvailable from '../../../../KodanshaUIKit/KodanshaAvailable/KodanshaAvailable';
import KodanshaArrow from '../../../../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import { useAtomValue } from 'jotai';
import { AccountInfoAtom } from '../../../../../store/AccountStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

interface DesktopHeaderProps {
    isProduct?: boolean;
    also?: boolean;
    coverUrl?: string;
    title?: string;
    series?: any;
    description?: string;
    subCategory?: string;
    volumeNumber?: number;
    id?: number;
    color?: string;
    name?: string;
    authors?: Creator[];
    assetLinkGroups?: any[];
}

const DesktopHeader = (props?: DesktopHeaderProps): ReactElement => {
    // const color = useRef(getRandomColor);
    const history = useHistory();
    const accountInfo = useAtomValue(AccountInfoAtom);

    console.log('props.series', props.series);
    return (
        <div className='series-desktop-header-container'>
            <div className='series-desktop-header-poster-wrapper'>
                {(!props.isProduct) && <div
                    style={{ backgroundColor: props?.coverUrl?.includes('kodansha_placeholder') ? getSeriesColor(props?.color) : getSeriesColor('red') }}
                    className='colorize' />}
                {props.isProduct ?
                    // <KodanshaPoster src={props.coverUrl} />
                    <ProductPoster preloadImage={true} hover={false} src={props?.coverUrl} alt={'cover for ' + props?.title} />
                    :
                    <SeriesPoster hover={false} src={props?.coverUrl} color={props?.color}
                                  alt={'cover for ' + props?.title} />
                    // <img alt={''} src={props.coverUrl} className='series-desktop-header-poster' />
                }


                <div className='product-header-breadcrumb-wrapper-loading'>
                    <KodanshaBreadCrumb
                        items={['Browse', props?.subCategory === 'Book' ? 'book' : 'manga', props?.series?.title, props.volumeNumber?.toString(), '']}
                        highlightLast={true}
                        links={['/browse',
                            props?.subCategory === 'Book' ? '/browse/book' : '/browse/manga',
                            '/series/' + props?.series?.readableUrl ?? props?.series?.id.toString(), history.location.pathname]}
                        styles='series-desktop-header-breadcrumb-styles' />
                </div>
            </div>

            <div className='series-desktop-header-info-wrapper'>
                <h1 className='series-desktop-header-info-title'>
                    {props?.subCategory === 'Volume' ?
                        (props.series && props?.title ? props?.series?.title : '') + (props.volumeNumber ? ', Volume ' + props?.volumeNumber : '') :
                        props?.name}

                    {props?.subCategory === 'Volume' && props?.series?.title === undefined ? props?.title : null}
                </h1>

                {/* TODO: Post Beta Feature */}
                {props.authors?.length > 0 && <span className='series-desktop-header-info-author'>
                    By {(props?.authors && mapCreators(props?.authors)) ?? ''}
                </span>}


                {accountInfo.roles?.find(x => x.toLowerCase() == 'admin') ?
                    <div className={'product-admin-edit'}>
                        <Link to={'/dashboard/products/' + props.id} className='edit-product-for-admin'>
                            <FontAwesomeIcon icon={faEdit} size='2x' />
                            <span>
                                Edit Product
                            </span>
                        </Link>
                        {/*//TODO: READER uses readable url*/}
                        <Link to={'/reader/' + props.id} className='edit-product-for-admin'>
                            <span>
                                Reader
                            </span>
                        </Link>
                    </div>
                    : null}


                {/* this is not recommended way for rendering html tags from the server */}
                <p className='series-desktop-header-info-description'
                   dangerouslySetInnerHTML={{ __html: props?.description }} />

                {/*<ul>*/}
                {/*    <li>This is a test for the list 1</li>*/}
                {/*    <li>This is a test for the list 2</li>*/}
                {/*    <li>This is a test for the list 3</li>*/}
                {/*    <li>This is a test for the list 4</li>*/}
                {/*    <li>This is a test for the list 5</li>*/}
                {/*</ul>*/}

                {/*<p className='series-desktop-header-info-description'>*/}

                {/*    {(props.description) ?? '\n' +*/}
                {/*        ' \n'}*/}
                {/*</p>*/}

                {/*<span className='series-desktop-header-info-award'>*/}
                {/*    Award text goes here when the backend supports it. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc fermentum quam vel lacus accumsan, placerat auctor est sodales. Pellentesque et sapien eget tortor ornare malesuada. Donec in tellus vel purus varius placerat non quis nulla. In commodo posuere sapien, ut congue justo tempus nec. Pellentesque nec fermentum erat, ut rutrum libero. Quisque diam dui, tempor et sapien at, dignissim cursus tellus. Duis rhoncus ullamcorper nisl, blandit eleifend ex.*/}
                {/*</span>*/}

                {/* TODO: Post Beta Feature */}
                {/*<div className='series-desktop-header-free-wrapper'>
                    <Free />
                </div>*/}

                <div className='series-desktop-header-available-book-wrapper'>
                    {props?.subCategory === 'Book' && formTheAssetGroup(props?.assetLinkGroups)?.map(items => {
                        return <KodanshaAvailable items={items}
                                                  also={props.also}
                                                  text={items?.some(i => i.name === 'Audio Files') ? 'Extras' : undefined}
                                                  scrollTo={((history.location.state as { isScroll: boolean })?.isScroll)} />;
                    })}
                </div>

            </div>
        </div>
    );
};

export default DesktopHeader;
